var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1234",
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1236"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M23.5 21H23v-9.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21h-2V1.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21H7V6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V21H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z",
    "data-name": "Bar Chart 2",
    className: "color303c42 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.15506408f590a6e334a24949d8d83d49.svg";
export { ForwardRef as ReactComponent };